// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"post-module--postContainer--j-lic","postContent":"post-module--postContent--1bfnt"};